'use client';

import { createClient } from '@/lib/supabase/client';

interface AssessmentResultData {
  email: string;
  fullName?: string;
  score: number;
  level: string;
  answers: Record<string, string>;
}

function isSchemaError(error: any): boolean {
  if (!error) return false;
  
  if (error.code && typeof error.code === 'string') {
    const errorClass = error.code.substring(0, 2);
    if (errorClass === '42' || errorClass === '08') {
      return true;
    }
    if (errorClass === '23') {
      return false;
    }
  }
  
  if (error.message) {
    const schemaErrorPatterns = [
      /relation.*does not exist/i,
      /column.*does not exist/i,
      /function.*does not exist/i,
      /syntax error/i,
      /invalid.*syntax/i,
      /type.*does not exist/i,
      /undefined.*column/i,
      /undefined.*table/i,
    ];
    return schemaErrorPatterns.some(pattern => pattern.test(error.message));
  }
  
  return false;
}

export const assessmentService = {
  async submitResult(data: AssessmentResultData) {
    const supabase = createClient();

    try {
      const { data: result, error } = await supabase
        .from('assessment_results')
        .insert({
          email: data.email,
          full_name: data.fullName || null,
          score: data.score,
          level: data.level,
          answers: data.answers,
        })
        .select()
        .single();

      if (error) {
        if (isSchemaError(error)) {
          console.error('Schema error:', error.message);
          throw error;
        } else {
          console.log('Data error:', error.message);
          return null;
        }
      }

      return result;
    } catch (error: any) {
      console.log('Schema-related error:', error.message);
      throw error;
    }
  },
};